module.exports = __webpack_public_path__ + "img/4.7def39e7.png";